import {
  Input,
  Modal,
  Form,
  Select,
  Button,
  Space,
  message,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle
} from "react";
import {
  UnorderedListOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import '../index.scss'

const ListModal = forwardRef(({submitInitFn}, ref) => {
  const [form] = Form.useForm();
  const [modalFlag, setModalFlag] = useState(false);
  const [isEditFlag, setIsEditFlag] = useState(true);
  const [record, setRecord] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [reportGroupList, setReportGroupList] = useState([]);
  const [reportAcctTypeList, setReportAcctTypeList] = useState([]);

  useImperativeHandle(ref, () => ({
     openModal: async({isEidt = false, record = {}} = {}) => {
      setIsEditFlag(isEidt)
      setRecord(record)
      setModalFlag(true)
    }
  }));

  const afterOpenChangeFn = (flag) => {
    if(flag){
      getReportGroupList()
      getAcctTypeListFn()
      if(isEditFlag){
        form.setFieldsValue({
          ...record
        })
      }
    }else{
      form.resetFields()
      setReportGroupList([])
      setReportAcctTypeList([])
      setBtnLoading(false);
    }
  }

  const getReportGroupList = async() => {
    const response = await http.get(api.operatingStatementAnalysisReportGroupList);
    setReportGroupList(response?.data || []);
  }

  const getAcctTypeListFn = async() => {
    const response = await http.get(api.operatingStatementAnalysisReportAcctTypeList, {params: {field: 'acct_type'}});
    setReportAcctTypeList(response?.data || []);
  }

  const submitFn = async() => {
    setBtnLoading(true)
    const params = {
      ... form.getFieldsValue(),
      reportListId: isEditFlag ? record?.reportListId : undefined,
    }
    const response = await http.post(isEditFlag ? api.operatingStatementAnalysisUpdateReportList : api.operatingStatementAnalysisCreateReportList, params);
    if(response.code === '1'){
      message.success(`Successfully ${isEditFlag ? 'Update' : 'Create'} List.`);
      setModalFlag(false)
      submitInitFn()
    }else{
      message.warning(`Failed ${isEditFlag ? 'Update' : 'Create'} List.`);
    }
    setBtnLoading(false)
  }
  
  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
          <UnorderedListOutlined style={{ marginRight: "8px" }} />
            {isEditFlag ? 'EDIT REPORT LIST' : 'Create LIST'}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      afterOpenChange={afterOpenChangeFn}
      width="50%"
      maskClosable={false}
      destroyOnClose={true}
    >
      <Form 
        form={form} 
        layout="vertical"
        initialValues={{
          isGroup: 0,
        }}
      >
        {!isEditFlag && <Form.Item
          name="reportGroupId"
          label="Report Group"
          rules={[{ required: true, message: 'Report Group is required!' }]}
        >
          <Select
            allowClear
            popupMatchSelectWidth={false}
            placeholder="Select a type"
            optionFilterProp="label"
            filterOption={(input, option) =>
              (option?.nameGroup ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            fieldNames={{
              label: 'nameGroup',
              value: 'reportGroupId',
            }}
            options={reportGroupList}
          />
        </Form.Item> || null}

        <Form.Item
          name="nameList"
          label="List Name"
          rules={[{ required: true, message: 'List Name is required!' }]}
        >
          <Input
            placeholder="Please input List Name"
          />
        </Form.Item>

        <Form.Item
          name="glList"
          label="Gl List"
          rules={[{ required: true, message: 'Gl List is required!' }]}

        >
          <Input.TextArea
            placeholder="Please input Gl List"
            autoSize={{ minRows: 3, maxRows: 10 }}
          />
        </Form.Item>

        <Form.Item
          name="acctTypeList"
          label="Acct Type List"
        >
          <Select
            allowClear
            popupMatchSelectWidth={false}
            placeholder="Select a type"
            optionFilterProp="label"
            filterOption={(input, option) =>
              (option?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            fieldNames={{
              label: 'label',
              value: 'value',
            }}
            options={reportAcctTypeList}
          />
        </Form.Item>

        <Form.Item
          name="isGroup"
          label="Group All GL to One Line"
          rules={[{ required: true, message: 'Group All GL to One Line is required!' }]}
        >
          <Select
            placeholder="Select Group All GL to One Line"
            options={[
              {
                value: 0,
                label: "No",
              },
              {
                value: 1,
                label: "Yes",
              },
            ]}
          />
        </Form.Item>
        
        {isEditFlag && <Form.Item
          name="usid"
          label="Usid"
          rules={[{ required: true, message: 'Usid is required!' }]}
        >
          <Input
            disabled
            placeholder="Please input Usid"
          />
        </Form.Item> || null}
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => submitFn()} loading={btnLoading}>
            Submit
          </Button>
        </Space>
      </div>
    </Modal>
  );
});
export default ListModal;
